<template>
  <div>

    <div class="text-center" v-if="!reflectionType">
      <h5 class="text-default font-weight-bold">
        <small>What do you want your group to reflect on?</small>
      </h5>
      <div class="row justify-content-center text-center">
        <div
          class="col-lg-2 col-sm-4 col-4 pt-2 pb-2 m-0 text-center justify-content-center"
          v-for="(rt, index) in filteredTypes"
          v-bind:key="index"
          @click="setReflectionType(rt)"
        >
          <div class="text-center">
            <img
              :alt="rt.name"
              class="img-rt img-rt-selection pointer"
              :src="rt.image"
            />
          </div>
          <div class="label-rt text-center text-default font-weight-bold pointer">
            {{ rt.name }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-center" 
      v-if="reflectionType && !form.ratingSaved && !reflectionType.special"
    >
      <h5 class="card-title text-default font-weight-bold">
        Create your group reflection
      </h5>
      <div class="row justify-content-center">
        <div class="col-lg-6 col-12 pt-3 pb-4 text-center">

          <div class="text-center">
            <img
              :alt="reflectionType.name"
              class="img-rt"
              :src="reflectionType.image"
            />
          </div>
          <div class="label-rt text-center text-default font-weight-bold">
            {{ reflectionType.name }}
          </div>

        </div>
      </div>

      <hr class="ml-0 mr-0">

      <h6 class="card-title text-muted font-weight-bold mt-5" v-if="showActivity">
        Name this reflection activity
      </h6>
      <div class="row justify-content-center" v-if="showActivity">
        <div class="col-lg-6 col-12 pt-1 pb-4">
          <base-input
            alternative
            v-model="form.activityName"
            class="mb-3 text-center"
            placeholder="Enter a title for this activity"
          >
          </base-input>
        </div>
      </div>

      <hr class="ml-0 mr-0" v-if="showActivity">

      <h6 class="card-title text-muted font-weight-bold mt-5">
        Tag your activity
      </h6>
      <div class="row justify-content-center pt-1 pb-4">
        <div class="col-12 mt-1 mb-0 p-2 text-center">
          <span
            :class="getTagClass(tag)"
            v-for="(tag, index) in filteredTags"
            v-bind:key="index"
            @click="setTag(tag)"
            :title="tag.title"
          >
            <span v-if="tag.scope === 'group'">
              <i class="fal fa-users-class"></i> {{ tag.label }}
            </span>
            <span v-else> <i class="fal fa-tag"></i> {{ tag.name }} </span>
          </span>
        </div>

      </div>

      <hr class="ml-0 mr-0">

      <attachment-builder ref="attachmentBuilder" :options="attachmentBuilderOptions"></attachment-builder>

      <div class="row justify-content-md-center" v-if="form.activityName && form.tag">
        <div class="col-lg-6 col-12 mt-5 pb-2">
          <base-button type="default" size="lg" block @click="createReflection">
            Send the Reflection
          </base-button>
        </div>
      </div>
      <div class="row justify-content-md-center" v-else>
        <div class="col-lg-6 col-12 mt-5 pb-2">
          <base-button type="default" size="lg" disabled block>
            Send the Reflection
          </base-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import Card from "@/components/Card";
import AttachmentBuilder from "@/components/reflections/AttachmentBuilder";
// import Modal from "@/components/Modal.vue";
// import BaseSwitch from "@/components/BaseSwitch.vue";
import firebase from "firebase/app";
import { db } from "@/firebase";
import store from "@/store.js";
import { mapGetters } from "vuex";

import reflectionTypes from "@/models/reflectionTypes";

import { VBPopover } from "bootstrap-vue/esm/directives/popover/popover";



export default {
  name: "group-reflection",
  components: {
    AttachmentBuilder
  },

  directives: {
    BPopover: VBPopover,
  },

  props: ["currentUser","group"],

  data() {
    return {
      hideModal: false,
      today: null,
      displayRego: false,
      reflectionTypes: reflectionTypes,
      hideConfirmation: false,
      showActivity: true,
      form: {
        analysis: null,
        action: null,
        activitySaved: false,
        activityName: "",
        activityDetails: "",
        imageURL: "",
        rating: 5,
        ratingSaved: false,
        highlightsSaved: false,
        highlights: [],
        lowlights: [],
        tempHighlight: "",
        tempLowlight: "",
        tag: null,
        tagData: null,
        alertStatus: null,
        dailyCheckinQuestions: [
          {
            id: "feeltoday",
            question: "How do I feel today?",
            type: "range",
            value: 5,
          },
          {
            id: "bestthing",
            question: "What was the best thing that happened to me today?",
            type: "text",
            value: "",
          },
          {
            id: "accomplishtomorrow",
            question: "What is the most important thing I must accomplish tomorrow?",
            type: "text",
            value: "",
          },
          {
            id: "newthing",
            question: "What is one thing that I can do to improve my day tomorrow?",
            type: "text",
            value: "",
          },
        ],
      },
      modals: {
        reflectionSaved: false,
      },

      consolidatedTags: [],

      reflectionDate: null,
      reflectionAdjustment: 0,

      addtag: false,

      // used during registration!
      fname: "",
      lname: "",
      email: "",
      password: "",
      uid: null,
      redirectToDashboard: false,

      tmpImage: null,
      tmpImageRotation: 0,
      uploadingImage: false,

      // currentUser: null,
      reflectionType: null,

      // Sentiment Analysis
      sentimentSource: null,
      skippedValues: 0,
      skipTolerance: 3,

      // Attachment Builder
      attachmentBuilderOptions: {
        supportDataCapture: true,
        templateType: 'group'
      }

    };
  },
  mounted() {
    this.setDate(0);
    this.buildTags();
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.consolidatedTags = [];
        this.buildTags();
      },
    }
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      // map `this.groups` to `this.$store.getters.groups`
      user: "user",
      groups: "groups",
    }),

    filteredTags() {
      if (this.consolidatedTags) {
        return this.consolidatedTags.filter((tag) => {
          return (
            tag.status === "active" &&
            (!tag.type || tag.type === this.reflectionType.name || tag.type === "none")
          );
        });
      }

      return [];
    },

    filteredTypes() {
      if (this.reflectionTypes) {
        return this.reflectionTypes.filter((rt) => {
          return !rt.special
        });
      }

      return [];
    },

  },
  methods: {

    rotateCCW() {
      if (this.tmpImageRotation === 0) {
        this.tmpImageRotation = 315;
      } else {
        this.tmpImageRotation -= 45;
      }
    },

    rotateCW() {
      if (this.tmpImageRotation >= 315) {
        this.tmpImageRotation = 0;
      } else {
        this.tmpImageRotation += 45;
      }
    },

    getClipResult: function () {
      const vm = this;

      const canvas = this.$refs.clipper.clip({ wPixel: 900 }); //call component's clip method
      canvas.toBlob(function (blob) {
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          vm.tmpImage = this.result;
        });
        vm.afterComplete(blob);
        // reader.readAsDataURL(blob);
      });
    },

    async afterComplete(upload) {
      const vm = this;

      vm.uploadingImage = true;
      var imageName = this.$uuid.v4();
      try {
        //save image
        let file = upload;
        var metadata = {
          contentType: "image/png",
        };
        var storageRef = firebase.storage().ref("reflections").child(this.user.data.uid);
        var imageRef = storageRef.child(`${imageName}.png`);
        await imageRef.put(file, metadata);
        var downloadURL = await imageRef.getDownloadURL();

        vm.form.imageURL = downloadURL;
        vm.closeUpload();
      } catch (error) {
        // console.log(error);
      }
    },

    closeUpload() {
      this.uploadingImage = false;
      this.tmpImage = null;
      this.tmpImageRotation = 0;
    },

    // Receive Registration Success message from form
    receiveRegStatus(uid) {
      this.uid = uid;
      this.redirectToDashboard = true;
      this.createReflection();
    },

    buildTags() {
      const vm = this;

      if (!vm.user.data) {
        return;
      }

      // Cycle through our groups
      let tmpGroups = [];
      if (vm.groups) {
        tmpGroups = JSON.parse(JSON.stringify(vm.groups));
      }

      tmpGroups.forEach((group, gi) => {
        // Add our tmpGroupTags
        var tmpGroupTags = JSON.parse(JSON.stringify(group.tags));
        tmpGroupTags.forEach((tag, t2i) => {
          tag.groupId = group.id;
          tag.title = group.groupName;
          tag.label = tag.name;
          tag.name = group.id + "#" + tag.name;
          vm.consolidatedTags.push(tag);
        });
      });
    },

    setTag(tag) {
      if (this.form.tag === tag.name) {
        this.form.tag = null;
        this.form.tagData = null;
      } else {
        this.form.tag = tag.name;
        this.form.tagData = tag;
      }
    },

    getTagClass(tag) {
      if (tag.scope === "group") {
        if (tag.name === this.form.tag) {
          return "pointer badge badge-pill badge-dark mb-2";
        } else {
          return "pointer badge badge-pill badge-light text-dark mb-2";
        }
      } else {
        if (tag.name === this.form.tag) {
          return "pointer badge badge-pill badge-default mb-2";
        } else {
          return "pointer badge badge-pill badge-light text-default mb-2";
        }
      }
    },

    getReflectionDate(datetime) {
      let myDate = new Date(datetime.seconds * 1000);
      return myDate;
    },

    setDate(days) {
      if (days === 0) {
        this.reflectionAdjustment = days;
      } else {
        this.reflectionAdjustment += days;
      }

      this.today = this.$dayjs().format("YYYY-MM-DD");
      let ourMoment = this.$dayjs().add(this.reflectionAdjustment, 'day').format();

      let ourDate = new Date(ourMoment);
      this.reflectionDate = new firebase.firestore.Timestamp.fromDate(ourDate);
    },

    setReflectionType(rt) {
      this.showActivity = true;
      this.hideModal = false;
      this.setDate(0);
      this.reflectionType = rt;
      if (this.autoActivityName(rt.name)) {
        this.form.activityName = rt.name;
        this.showActivity = false;
      }
    },

    autoActivityName(name) {
      let autoActivityNames = ["sleep", "journal entry", "daily checkin"];
      return autoActivityNames.includes(name);
    },

    highlightsSaved(){

      var doc = db.collection("reflections").doc();
      this.form.id = doc.id;

      this.commitHighlight();
      this.commitLowlight();
      this.form.highlightsSaved = true;
      this.buildSentimentSource();

    },

    buildPopOverContent(value) {
      let popover = {
        variant: "primary",
        content: value,
      };

      return popover;
    },

    buildFAQLink() {
      let popover = {
        variant: "primary",
        content:
          'Not sure what highlights & lowlights are? <a href="https://www.myreflections.app/faq/reflection-tips/what-are-highlights-and-lowlights" target="_blank">click here to learn</a>',
        html: true,
      };

      return popover;
    },

    buildTagLink() {
      let popover = {
        variant: "primary",
        content:
          'Not sure what tags are? <a href="https://www.myreflections.app/faq/reflection-tips/what-are-tags" target="_blank">click here to learn</a>',
        html: true,
      };

      return popover;
    },

    commitHighlight() {
      if (this.form.tempHighlight) {
        this.form.highlights.push(this.form.tempHighlight.trim());
        this.form.tempHighlight = "";
      }
    },

    commitLowlight() {
      if (this.form.tempLowlight) {
        this.form.lowlights.push(this.form.tempLowlight.trim());
        this.form.tempLowlight = "";
      }
    },

    deleteHighlight(i) {
      this.form.highlights.splice(i, 1);
    },

    deleteLowlight(i) {
      this.form.lowlights.splice(i, 1);
    },

    getActivityClass(action) {
      if (this.form.action === action) {
        return "action_active col-3 m-1 p-2 text-center";
      } else {
        return "col-3 m-1 p-2 text-center";
      }
    },

    setActivity(action) {
      this.form.action = action;
    },

    saveActivity() {
      this.form.activitySaved = true;
    },

    getRatingImage(rating) {
      return "img/images/values/circled-" + rating + ".svg";
    },

    clearReflection() {
      // console.log('reflection cleared')

      this.form = {
        analysis: null,
        action: null,
        activitySaved: false,
        activityName: "",
        activityDetails: "",
        imageURL: "",
        rating: 5,
        ratingSaved: false,
        highlightsSaved: false,
        highlights: [],
        lowlights: [],
        tempHighlight: "",
        tempLowlight: "",
        tag: null,
        tagData: null,
        alertStatus: null,
        dailyCheckinQuestions: [
          {
            id: "feeltoday",
            question: "How do I feel today?",
            type: "range",
            value: 5,
          },
          {
            id: "bestthing",
            question: "What was the best thing that happened to me today?",
            type: "text",
            value: "",
          },
          {
            id: "accomplishtomorrow",
            question: "What is the most important thing I must accomplish tomorrow?",
            type: "text",
            value: "",
          },
          {
            id: "newthing",
            question: "What is one thing that I can do to improve my day tomorrow?",
            type: "text",
            value: "",
          },
        ],
      };

      this.reflectionType = null;
      this.hideModal = true;
    },

    formatDailyCheckinQuestions(name, questions) {
      if (name !== "daily checkin") {
        return null;
      }

      questions.forEach((q, i) => {
        if (q.type === "range") {
          questions[i].value = Number(q.value);
        }
      });

      return questions;
    },

    createAlertStatus() {
      if (!this.user.data.alerts) {
        return null;
      }

      return JSON.stringify(this.user.data.alerts);
    },

    sendEmail(reflection){

          let emailRef = db.collection("mail").doc();
          let subject = "New group reflection from " + reflection.tagData.title + "! Complete your " + reflection.reflectionType + " group reflection now @ My Reflections!"
          let message = "You are getting this email because your group has a new group reflection titled " + reflection.activityName + "!"
          let btn_text = "Click here to reflect now!"
          let cta = "https://www.myreflections.app/reflectnow/" + reflection.id

          let emailData = {
            id: emailRef.id,
            from: "My Reflections <noreply@myreflections.app>",
            message: {
              subject: subject,
              text: message + "\n\n" + btn_text + " " + cta,
              html: '<!DOCTYPE html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title></title> <!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style type="text/css">#outlook a{padding:0}.ReadMsgBody{width:100%}.ExternalClass{width:100%}.ExternalClass *{line-height:100%}body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}table,td{border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt}img{border:0;height:auto;line-height:100%;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic}p{display:block;margin:13px 0}</style><!--[if !mso]><!--><style type="text/css">@media only screen and (max-width:480px){@-ms-viewport{width:320px}@viewport{width:320px}}</style><!--<![endif]--> <!--[if mso]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--> <!--[if lte mso 11]><style type="text/css">.outlook-group-fix{width:100% !important}</style><![endif]--> <!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css"><link href="https://fonts.googleapis.com/css?family=Cabin:400,700" rel="stylesheet" type="text/css"><style type="text/css">@import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);@import url(https://fonts.googleapis.com/css?family=Cabin:400,700);</style><!--<![endif]--><style type="text/css">@media only screen and (min-width:480px){.mj-column-per-100{width:100% !important;max-width:100%}}</style><style type="text/css">@media only screen and (max-width:480px){table.full-width-mobile{width:100% !important}td.full-width-mobile{width:auto !important}}</style><style type="text/css">.hide_on_mobile{display:none !important}@media only screen and (min-width: 480px){.hide_on_mobile{display:block !important}}.hide_section_on_mobile{display:none !important}@media only screen and (min-width: 480px){.hide_section_on_mobile{display:table !important}}.hide_on_desktop{display:block !important}@media only screen and (min-width: 480px){.hide_on_desktop{display:none !important}}.hide_section_on_desktop{display:table !important}@media only screen and (min-width: 480px){.hide_section_on_desktop{display:none !important}}[owa] .mj-column-per-100{width:100%!important}[owa] .mj-column-per-50{width:50%!important}[owa] .mj-column-per-33{width:33.333333333333336%!important}p{margin:0px}@media only print and (min-width:480px){.mj-column-per-100{width:100%!important}.mj-column-per-40{width:40%!important}.mj-column-per-60{width:60%!important}.mj-column-per-50{width:50%!important}mj-column-per-33{width:33.333333333333336%!important}}</style></head><body style="background-color:#FFFFFF;"><div style="background-color:#FFFFFF;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#8D6C9F;background-color:#8D6C9F;width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:210px;"><img alt="My Reflections" height="auto" src="https://firebasestorage.googleapis.com/v0/b/my-reflection-22932.appspot.com/o/FCMImages%2Fhor-white-nobrain-w350.png?alt=media&amp;token=445697bf-37e1-4302-a3ca-70fee26df5ad" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="210"></td></tr></tbody></table></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="background:#FFFFFF;background-color:#FFFFFF;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:0px 20px 0px 20px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:11px;line-height:1.5;text-align:center;color:#000000;"><h3 style="font-family: &apos;Cabin&apos;, sans-serif; font-size: 20px; color: #555555; line-height: 100%;">' + subject + '</h3></div></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="background:#FFFFFF;background-color:#FFFFFF;Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#FFFFFF;background-color:#FFFFFF;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="left" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:11px;line-height:1.5;text-align:left;color:#000000;"><p style="text-align: center;"><span style="font-size: 16px;">' + message.replace(/ - /g, '<br><br>') + '</span></p></div></td></tr><tr><td align="center" vertical-align="middle" style="font-size:0px;padding:15px 15px 15px 15px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;width:auto;line-height:100%;"><tbody><tr><td align="center" bgcolor="#8D6C9F" role="presentation" style="border:none;border-radius:0px;cursor:auto;mso-padding-alt:10px 30px 10px 30px;background:#8D6C9F;" valign="middle"> <a href="' + cta + '" style="display:inline-block;background:#8D6C9F;color:#ffffff;font-family:Ubuntu, Helvetica, Arial, sans-serif, Helvetica, Arial, sans-serif;font-size:15px;font-weight:normal;line-height:100%;Margin:0;text-decoration:none;text-transform:none;padding:10px 30px 10px 30px;mso-padding-alt:0px;border-radius:0px;" target="_blank">' + btn_text + '</a></td></tr></tbody></table></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.facebook.com/myreflectionsapp" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/facebook.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.twitter.com/myreflections20" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/twitter.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td><td> <![endif]--><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;"><tbody><tr><td style="padding:4px;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:transparent;border-radius:3px;width:35px;"><tbody><tr><td style="font-size:0;height:35px;vertical-align:middle;width:35px;"> <a href="https://www.instagram.com/myreflectionsapp/" target="_blank"> <img height="35" src="https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/social-icos/outlined/instagram.png" style="border-radius:3px;display:block;" width="35"> </a></td></tr></tbody></table></td></tr></tbody></table> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr><tr><td style="font-size:0px;padding:10px 25px;padding-top:10px;padding-right:100px;padding-bottom:10px;padding-left:100px;word-break:break-word;"><p style="border-top:solid 1px #CCCCCC;font-size:1;margin:0px auto;width:100%;"></p> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 1px #CCCCCC;font-size:1;margin:0px auto;width:400px;" role="presentation" width="400px" ><tr><td style="height:0;line-height:0;"> &nbsp;</td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td> <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"> <![endif]--><div style="Margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;vertical-align:top;"> <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" > <![endif]--><div class="mj-column-per-100 outlook-group-fix" style="font-size:13px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tbody><tr><td align="center" style="font-size:0px;padding:0px 0px 0px 0px;word-break:break-word;"><div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:15px;line-height:1.5;text-align:center;color:#949494;"><p><span style="font-size: 12px;">Copyright &#xA9; 2020 My Reflections, All rights reserved.&#xA0;<br></span></p></div></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div> <!--[if mso | IE]></td></tr></table> <![endif]--></td></tr></tbody></table></div></body></html>'
              
            },
            toUids: [reflection.uid]
          }

          emailRef.set(emailData);

    },

    createReflection() {

      // Let's make sure that any unsaved lowlights/highlights are saved first
      this.commitHighlight();
      this.commitLowlight();

      const vm = this;

      let userid = vm.uid;
      if (!userid) {
        userid = vm.currentUser.uid;
      }

      let tag = vm.form.tag;
      if (!tag) {
        tag = "none";
      }

      let tagData = vm.form.tagData;
      if (!tagData) {
        tagData = null;
      }

      let groupDocumentId = vm.$uuid.v4()

      let attachment = []
      if(this.$refs.attachmentBuilder.attachments){
        attachment = this.$refs.attachmentBuilder.attachments
      }

      let reflection = {
        attachment: attachment,
        analysis: vm.form.analysis,
        activityName: vm.form.activityName.trim(),
        activityDetails: vm.form.activityDetails.trim(),
        reflectionType: vm.reflectionType.name.trim(),
        groupReflection: true,
        groupDocumentId: groupDocumentId,
        imageURL: vm.form.imageURL,
        highlights: [],
        lowlights: [],
        creationTime: vm.reflectionDate,
        creationSeconds: vm.reflectionDate.seconds,
        lastUpdatedTime: vm.reflectionDate,
        tag: tag,
        tagData: tagData,
        dailyCheckinQuestions: vm.formatDailyCheckinQuestions(
          vm.reflectionType.name,
          vm.form.dailyCheckinQuestions
        ),
        // alertStatus: vm.createAlertStatus(),
      };

      let groupMembers = vm.group.members
      groupMembers.forEach((member, mi) => {
        
        let doc = db.collection("reflections").doc();
        let docid = doc.id

        reflection.id = docid
        reflection.member = member;
        reflection.uid = member.uid;

        // Send our Analytics event
        vm.$analytics.logEvent("group_reflection_created", reflection);

        db.collection("reflections")
          .doc(docid)
          .set(reflection)
          .then(function (docRef) {
            // nothing done!
          })
          .catch(function (error) {
            // console.log(error)

            vm.$toast.open({
              message: "Something went wrong!",
              type: "error",
              duration: 10000,
              // all of other options may go here
            });
          });

          // Send an email notification
          vm.sendEmail(reflection);

        });

      vm.clearReflection();

      vm.$toast.open({
        message: "Group Reflection saved!",
        type: "success",
        // all of other options may go here
      });

    }

  },
};
</script>

<style scoped>
.action_active {
  border: 2px dashed #8d6c9f;
  border-radius: 25px;
}

.bg-rt {
  background: #e6dfea;
}

.img-rt {
  /* position: relative; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 60px;
  height: 60px;
  transition: transform 0.2s;
}

.img-rt-selection:hover {
  transform: scale(1.1);
}

.img-report {
  position: relative;
  top: 0;
  left: 0;
  width: 35px;
  height: 35px;
}

.label-rt {
  font-size: 0.7em;
}

.img-hlll {
  width: 75px;
  height: 75px;
}

.img-rating {
  position: absolute;
  top: 57px;
  margin: 0 0 0 -14px;
  width: 30px;
  height: 30px;
}

/* rating */

input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
  margin: 15.7px 0;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 4.6px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  background: #e6dfea;
  border-radius: 2.4px;
  border: 0px solid rgba(1, 1, 1, 0);
}

input[type="range"]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid rgba(0, 0, 0, 0);
  height: 36px;
  width: 36px;
  border-radius: 47px;
  background: #8d6c9f;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -15.7px;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #f2eef4;
}

input[type="range"]::-moz-range-track {
  width: 100%;
  height: 4.6px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
  background: #e6dfea;
  border-radius: 2.4px;
  border: 0px solid rgba(1, 1, 1, 0);
}

input[type="range"]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid rgba(0, 0, 0, 0);
  height: 36px;
  width: 36px;
  border-radius: 47px;
  background: #8d6c9f;
  cursor: pointer;
}

input[type="range"]::-ms-track {
  width: 100%;
  height: 4.6px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}

input[type="range"]::-ms-fill-lower {
  background: #dad0e0;
  border: 0px solid rgba(1, 1, 1, 0);
  border-radius: 4.8px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
}

input[type="range"]::-ms-fill-upper {
  background: #e6dfea;
  border: 0px solid rgba(1, 1, 1, 0);
  border-radius: 4.8px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0);
}

input[type="range"]::-ms-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid rgba(0, 0, 0, 0);
  height: 36px;
  width: 36px;
  border-radius: 47px;
  background: #8d6c9f;
  cursor: pointer;
  height: 4.6px;
}

input[type="range"]:focus::-ms-fill-lower {
  background: #e6dfea;
}

input[type="range"]:focus::-ms-fill-upper {
  background: #f2eef4;
}
</style>
